module.exports = __webpack_public_path__ + "static/media/10_Micha.8caaba4c.png";